import { makeStyles } from 'tss-react/mui';

const styles = () => ({
  root: {
    height: '70vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'center' as const,
    alignItems: 'center' as const,
    gap: 16,
  },
});

export default makeStyles()(styles);
